<script>
export default {
    name: "MobileButtonToggle",
    props: { label: String },
    emits: [ "mobile-toggle" ]
};
</script>

<template>
    <div class="flex">
        <img class="btn" src="@/assets/Images/M/IconNavigationPrimary.png" alt="Icon - Mobile Primary Navigation" title="Mobile Primary Navigation" @click="$emit('mobile-toggle')"/>
        <span id="mobile-navigation-label">{{ label }}</span>
    </div>
</template>